/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-07-03 14:40:36
 */
import Vue from "vue";
import Vuex from "vuex";
// import Cookies from "js-cookie";
import routerData from "./modules/routerData";
import role from "./modules/role";
import view from "./modules/view";
import gpy from "./modules/gpy";
import layout from "./modules/layout/index";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loginCode: "",
    userId: "",
    userInfo: "",
    //token: localStorage.getItem("token")?localStorage.getItem("token"):token,
    token: localStorage.getItem("token"),
    noticeNum: "",
    // accountId: Cookies.get("accountId"),
    // userName: Cookies.get("userName"),
    // roleName: Cookies.get("roleName"),
    // staffName: Cookies.get("staffName"),
    // companyShortName: Cookies.get("companyShortName"),
    accountId: localStorage.getItem("accountId"),
    userName: localStorage.getItem("userName"),
    roleName: localStorage.getItem("roleName"),
    staffName: localStorage.getItem("staffName"),
    companyShortName: localStorage.getItem("companyShortName"),
    remindId: "",
    printShow: false
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      // Cookies.set("token", token, { expires: 1 / 24 });
    },
    setprintShow: (state, code) => {
      state.printShow = code;
    },
    setLogincode: (state, code) => {
      state.loginCode = code;
    },
    setUserId: (state, id) => {
      state.userId = id;
    },
    setRemindId: (state, remindId) => {
      state.remindId = remindId;
    },
    setCompanyShortName: (state, companyShortName) => {
      state.companyShortName = companyShortName;
      localStorage.setItem("companyShortName", companyShortName);
   /*   Cookies.set("companyShortName", companyShortName);*/
    },
    setUserName: (state, name) => {
      state.userName = name;
      localStorage.setItem("userName", name);
    /*  Cookies.set("userName", name);*/
    },
    setUserInfo: (state, info) => {
      state.userInfo = info;
    },
    setRoleName: (state, roleName) => {
      state.roleName = roleName;
      localStorage.setItem("roleName", roleName);
     /* Cookies.set("roleName", roleName);*/
    },
    setStaffName: (state, staffName) => {
      state.staffName = staffName;
      localStorage.setItem("staffName", staffName);
      // Cookies.set("staffName", staffName);
    },
    setAccountId: (state, accountId) => {
      state.accountId = accountId;
      localStorage.setItem("accountId", accountId);
   /*   Cookies.set("accountId", accountId);*/
    },
    setMenu: (state, menu) => {
      state.menu = menu;
    },
    setNoticeNum: (state, noticeNum) => {
      state.noticeNum = noticeNum;
    }
  },
  actions: {
    setprintShow({ commit }, code) {
      commit("setprintShow", code);
    },
    setRemindId({ commit }, remindId) {
      commit("setRemindId", remindId);
    },
    setCompanyShortName({ commit }, companyShortName) {
      commit("setCompanyShortName", companyShortName);
    },
    setMenu({ commit }, menu) {
      commit("setMenu", menu);
    },
    setNoticeNum({ commit }, noticeNum) {
      commit("setNoticeNum", noticeNum);
    },
    setToken({ commit }, token) {
      return new Promise((resolve, reject) => {
        commit("setToken", token);
        resolve();
      });
    },
    setAccountId({ commit }, accountId) {
      commit("setAccountId", accountId);
      /*return new Promise((resolve, reject) => {
        commit("setAccountId", accountId);
        resolve();
      });*/
    },
    setStaffName({ commit }, staffName) {
      commit("setStaffName", staffName);
    },
    setRoleName({ commit }, roleName) {
      commit("setRoleName", roleName);
    },
    setUserName({ commit }, name) {
      commit("setUserName", name);
    },
    setUserId({ commit }, id) {
      commit("setUserId", id);
    },
    setLogincode({ dispatch }, code) {
      dispatch("setLogincode", code);
    },
    setUserInfo({ dispatch }, info) {
      dispatch("setUserInfo", info);
    }
  },
  getters: {
    setprintShow: state => state.setprintShow,
    menu: state => state.menu,
    roleName: state => state.roleName,
    staffName: state => state.setStaffName,
    accountId: state => state.accountId,
    userName: state => state.userName,
    addRouters: state => state.routerData.addRouters,
    token: state => state.token,
    info: state => state.role.info,
    routers: state => state.routerData.routers,
    titleShow: state => state.layout.titleShow,
    logoShow: state => state.layout.logoShow,
    isCollapse: state => state.layout.isCollapse,
    uniquerouter: state => state.layout.uniquerouter,
    tabnavBox: state => state.layout.tabnavBox,
    visible: state => state.layout.visible,
    left: state => state.layout.left,
    top: state => state.layout.top,
    rightNav: state => state.layout.rightNav
  },
  modules: {
    routerData,
    role,
    view,
    gpy,
    layout
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.js